import { useAccount } from '@bnnvara/accounts';
import React from 'react';

import { Bookmarks } from './Bookmarks/Bookmarks';
import { FollowedBrands } from './FollowedBrands/FollowedBrands';
import { ProfileFollowThemes } from './ProfileFollowThemes/ProfileFollowThemes';
import { EditorialNotificationSettings } from './NotificationSettings/EditorialNotificationSettings';

export function ProfileLoggedIn() {
  const {
    profile: { UID },
  } = useAccount();

  return (
    <>
      <Bookmarks />

      <EditorialNotificationSettings UID={UID} />

      <ProfileFollowThemes />

      <FollowedBrands />
    </>
  );
}
